// TabBar — web-port 1-op-1 van app/(tabs)/_layout.tsx
// Navy achtergrond, geen bovenrand, actief = goud, inactief = inkFaint.
import React from 'react';
import Icon from '../../Icon';

const ITEMS = [
  ['ontdek', 'compass', 'Ontdek'],
  ['swipe', 'layers', 'Swipe'],
  ['bezoeken', 'calendar', 'Bezoeken'],
  ['profiel', 'user', 'Profiel'],
];

export default function TabBar({ active }) {
  return (
    <div data-testid="tab-bar" style={{
      display: 'flex', background: '#102A43', height: 68, paddingTop: 8,
      boxSizing: 'border-box', flexShrink: 0,
    }}>
      {ITEMS.map(([key, icon, label]) => {
        const on = active === key;
        const color = on ? '#C48A3A' : '#94A2B4';
        return (
          <div key={key} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
            <Icon name={icon} size={20} color={color} />
            <span style={{ fontSize: 11, fontWeight: 600, letterSpacing: 0.4, color, marginBottom: 4 }}>{label}</span>
          </div>
        );
      })}
    </div>
  );
}
